import React from 'react'
import { EXPORT_TROUTE_MODAL } from '../ExportTRouteModal'
import { ModalOverlay } from 'common/styleguide/ModalOverlay'
import { ExportFormatContainer } from 'common/ExportFormats'
import { CTA } from 'common/styleguide/CTA'
import { interfaceBase } from 'lib/styleguide/base.scss'
import { formatsForObjectType } from 'lib/exportFormats'
import { showModal } from 'lib/modalUtils'
import { FormattedMessage as T } from 'react-intl'

export const QUICK_EXPORT_MODAL = 'QUICK_EXPORT_MODAL'

export class QuickExportModal extends React.PureComponent {
  moreOptionsClicked = (e) => {
    e.preventDefault()

    showModal(EXPORT_TROUTE_MODAL)
    this.props.onRequestClose()
  }

  render () {
    const { route, onRequestClose, format } = this.props

    const f = formatsForObjectType('route').get(format)

    return (
      <ModalOverlay
        title={<span>
          <T
            id='QuickExportModal.exportFile'
            defaultMessage='Export <strong>{fileType} file</strong>'
            values={{
              strong: (...c) => <strong>{c}</strong>,
              fileType: f.ext.toUpperCase()
            }} />
        </span>}
        maxWidth='400px'
        onRequestClose={onRequestClose}>
        <div className={interfaceBase}>
          <ExportFormatContainer
            troute={route}
            objectType='route'
            f={f} />
          <CTA link margins={false} onClick={this.moreOptionsClicked}>
            <T id='QuickExportModal.otherFormats' defaultMessage='Other Formats' />
          </CTA>
        </div>
      </ModalOverlay>
    )
  }
}
